import { render, staticRenderFns } from "./KM_analysis.vue?vue&type=template&id=17b22dd8"
import script from "./KM_analysis.vue?vue&type=script&lang=js"
export * from "./KM_analysis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports